import { render, staticRenderFns } from "./FlexmessageTextAction.vue?vue&type=template&id=77c55b7d&scoped=true&"
import script from "./FlexmessageTextAction.vue?vue&type=script&lang=js&"
export * from "./FlexmessageTextAction.vue?vue&type=script&lang=js&"
import style0 from "./FlexmessageTextAction.vue?vue&type=style&index=0&id=77c55b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c55b7d",
  null
  
)

export default component.exports